/**
 * @file: useVehicleInspectionSubjects.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCurrentUserDangerously } from '@euler/app/flows/auth/context';
import { useAsyncStorage } from '@euler/functions/useAsyncStorage';
import { VehicleInspectionSubject } from '@euler/model';
import { useServiceFactory } from '@euler/services/factory';
import { useEffect } from 'react';

export function useVehicleInspectionSubjects() {
  const { storeService } = useServiceFactory();
  const user = useCurrentUserDangerously();
  const [subjects, updateSubjects] = useAsyncStorage<
    VehicleInspectionSubject[]
  >(`${user.org.id}:${user.store.id}:inspection-subjects`);
  useEffect(() => {
    storeService
      .getVehicleInspectionSubjects()
      .then(updateSubjects)
      .catch(err => {
        console.error(err);
      });
  }, [storeService, updateSubjects]);
  return subjects ?? [];
}
